import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiDelete } from '@/lib/http/client';
import {
  portfolioInvitationUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';

interface CancelInvitationParams {
  invitationId: string;
}

export function useCancelInvitation(portfolioId: number, orgId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ invitationId }: CancelInvitationParams) =>
      apiDelete(portfolioInvitationUrl(portfolioId, orgId, invitationId)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgInvitations(portfolioId, orgId),
      });
    },
  });
}
